import { request } from "../request";
import { isHXApp } from "@saas/components/src";
// 获取课程列表
export const getCourseList = (params) =>
  request(`/v1/course/getList`, "get", { params });
// 获取详细报告
export const getLiveReport = (params) =>
  request(`/v1/course/live/report`, "get", { params });
// 获取课程标签状态
export const getCourseState = (params) =>
  request(`/v1/course/getCourseState`, "get", { params });
// 获取已购课程标签状态
export const getCoursesState = (params) =>
  request(`/v1/course/getCoursesState`, "get", { params });
// 课时预约
export const bookingLesson = (params) =>
  request(`/v1/course/lesson/booking`, "post", { json: params });
// 上传文件
export const saveFile = (params) =>
  request(`/v1/seller/course/file/saveFile`, "post", { json: params });
// 获取群聊文件
export const getFileList = (params) =>
  request(`/v1/course/file/getList`, "get", { params });
export const getAllMaterialId = (params) =>
  request(`/v1/seller/course/file/getAllMaterialId`, "get", { params });
// 设置重点文件
export const setImportant = (params) =>
  request(`/v1/course/file/setImportant`, "post", { json: params });
// 作业列表
export const getWorkList = (params) =>
  request(`/v1/course/work/list`, "get", {
    params: {
      answer_type: isHXApp() ? 1 : 0,
      ...params,
    },
  });
// 开启/关闭作业提醒
export const updateWorkWarn = (params) =>
  request(`/v1/seller/lesson/updateWorkWarn`, "POST", { json: params });

// 获取课时问答列表数据
export const getLessonQA = (params) =>
  request(`/v1/course/getAiLessonMessageList`, "get", { params });
// 更新课时笔记
export const updateLessonNote = (params) =>
  request(`/v1/course/updateAiLessonSummary`, "POST", { json: params });

// 获取课时笔记
export const getLessonNote = (params) =>
  request(`/v1/userCourse/notes/getByLessonId`, "get", { params });
// 保存课时笔记
export const saveLessonNote = (params) =>
  request(`/v1/userCourse/notes/save`, "POST", { json: params });

// ai会话点赞或者踩
export const aiLessonMessageLike = (params) =>
  request(`/v1/course/lessonMessage/comment`, "POST", { json: params });
// 获取待领取课程
export const getPendingCourse = (params) =>
  request(`/v1/enrollment/invite`, "get", { params });
